// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"7bd24176","175":"645781fb","192":"4f2f26d1","330":"57e37da4","452":"caac8755","828":"51adf6fb","842":"9872ce90"}[chunkId] + ".chunk.js";
};